module.exports = __webpack_public_path__ + "static/media/labTech.08fda31f.svg";